// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__344QJ","row":"styles_row__20mj4"};